// extracted by css-extract-rspack-plugin
export default {"resizeSurface":"KOR4a_FekLAUBq7X","resizeSnapshot":"VrprvdnfcMM8ExFI"};